const product = {
  //
}

export default product
